<template>
  <svg width="100%" :height="hauteurBloc"
        style="display: block" >
    <g v-for="vente in ventes" :key="vente.key">
        <rect
        :x="vente.x1String" :y="vente.yString"
        :width="vente.widthString" rx="2" ry="2" :height="hauteurLigne"
        :fill="vente.fill"/>
        <text v-if="vente.label"
        :x="vente.xmilieuString" :y="vente.yLabelString"
        dominant-baseline="central" text-anchor="middle"
        font-size="10" fill="white">{{ vente.label }}</text>
    </g>
  </svg>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import getRectangle from '@/services/catalogue/planningHelper';
import decorateurRectangleNumeriqueChildLc from '@/services/decorateur/decorateurRectangleNumeriqueChildLc';
import decorateurRectangleNumeriqueChildReseau from '@/services/decorateur/decorateurRectangleNumeriqueChildReseau';

const venteNumerique = createNamespacedHelpers('venteNumerique');

export default {
  props: ['data'],
  data() {
    return {
      hauteurLigne: '100%',
      hauteurBloc: '36px',
      ventes: [],
    };
  },
  computed: {
    ...venteNumerique.mapGetters([
      'criterePlanning',
    ]),
  },
  async mounted() {
    const ventesArray = [];
    const dateStart = this.criterePlanning.dateStart;
    const dateEnd = this.criterePlanning.dateStart.clone().add(this.criterePlanning.days, 'days');
    const filteredLc = this.data.affectations.filter(cmd =>
      dateStart <= moment(cmd.dateFin) && dateEnd >= moment(cmd.dateDebut));
    filteredLc.sort((a, b) => a.dateDebut.localeCompare(b.dateDebut));
    const context = {
      endLine1: '20000101',
      endLine2: '20000101',
    };
    filteredLc.forEach(cmd => {
      const result = getRectangle(this.criterePlanning,
        moment(cmd.dateDebut),
        moment(cmd.dateFin));
      decorateurRectangleNumeriqueChildLc(result, cmd, context);
      ventesArray.push(result);
    });
    const filteredReseau = this.data.affectationsReseaux.filter(reseau =>
      dateStart <= moment(reseau.dateFin) && dateEnd >= moment(reseau.dateDebut));
    filteredReseau.forEach(reseau => {
      const result = getRectangle(this.criterePlanning,
        moment(reseau.dateDebut),
        moment(reseau.dateFin));
      decorateurRectangleNumeriqueChildReseau(result, reseau);
      ventesArray.push(result);
    });
    let hBloc = 0;
    hBloc = 36 * ventesArray.length;
    this.hauteurBloc = hBloc + 'px';
    let hLigne = 0;
    hLigne = 100 / ventesArray.length;
    this.hauteurLigne = hLigne + '%';
    ventesArray.forEach(ligne => { ligne.yString = (36 * ligne.line) + 'px'; ligne.yLabelString = (36 * ligne.line + 18) + 'px'; });
    this.ventes = ventesArray;
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/recherche/planningNumeriqueChildSvg.vue